<template>
    <div
        ref="convstooltip"
        class="con-vs-tooltip"
        @mouseleave="mouseleavex"
        @mouseenter="mouseenterx"
    >
        <transition :name="entryAnimation">
            <div
                v-show="activeTooltip"
                ref="vstooltip"
                :class="[colorClass, `position-${location}`, { 'after-none': noneAfter }]"
                :style="style"
                class="vs-tooltip"
            >
                <slot name="content">
                    <h4 v-if="title" class="tooltip-title">{{ title }}</h4>
                    <span v-html="text"> </span>
                </slot>
            </div>
        </transition>
        <slot></slot>
    </div>
</template>

<script>
import utils from '@/assets/utils'
import _color from '@/assets/utils/color.js'

export default {
    name: 'VxTooltip',
    props: {
        title: {
            default: null,
            type: [String, Number]
        },
        text: {
            default: null,
            type: [String, Number]
        },
        color: {
            default: null,
            type: String
        },
        position: {
            default: 'top',
            type: String
        },
        delay: {
            default: '0s',
            type: [Number, String]
        },
        active: {
            default: true,
            type: [Boolean]
        },
        value: {
            default: false,
            type: Boolean
        }
    },
    data() {
        return {
            cords: {},
            activeTooltip: this.value,
            widthx: 'auto',
            positionx: null,
            noneAfter: false
        }
    },
    computed: {
        style() {
            return {
                left: this.cords.left,
                top: this.cords.top,
                transitionDelay: this.activeTooltip ? this.delay : '0s',
                background: _color.getColor(this.color, 1),
                width: this.widthx
            }
        },
        colorClass() {
            if (this.color) {
                return `vs-tooltip-${this.color}`
            }
            return ''
        },
        entryAnimation() {
            switch (this.location) {
                case 'left':
                    return 'slide-fade-left'
                case 'right':
                    return 'slide-fade-right'
                case 'bottom':
                    return 'slide-fade-up'
                default:
                    return 'slide-fade-down'
            }
        },
        location() {
            var pos = this.position.trim()
            if (pos == 'left') {
                return 'left'
            }
            if (pos == 'right') {
                return 'right'
            }
            if (pos.contains('bottom')) {
                return 'bottom'
            }
            if (pos.contains('top')) {
                return 'top'
            }
        }
    },
    watch: {
        value(val) {
            this.activeTooltip = val
        },
        activeTooltip(val) {
            if (this.value !== val) {
                this.$emit('input', val)
            }
        }
    },
    mounted() {
        // utils.insertBody(this.$refs.vstooltip)
    },
    updated() {
        if (!this.$slots.default) {
            this.activeTooltip = false
        }
    },
    beforeDestroy() {
        if (this.$refs.vstooltip && this.activeTooltip) {
            utils.removeBody(this.$refs.vstooltip)
        }
    },
    methods: {
        mouseenterx() {
            if (this.active) {
                this.activeTooltip = true
                this.$nextTick(() => {
                    utils.insertBody(this.$refs.vstooltip)
                    this.changePosition(this.$refs.convstooltip, this.$refs.vstooltip)
                })
            }
        },
        mouseleavex() {
            this.activeTooltip = false
            if (this.$refs.vstooltip) {
                utils.removeBody(this.$refs.vstooltip)
            }
        },
        changePosition(elxEvent, tooltip) {
            this.noneAfter = false
            this.positionx = null
            let elx = elxEvent.closest('.con-vs-tooltip')
            let scrollTopx = window.pageYOffset || document.documentElement.scrollTop
            let topx = elx.getBoundingClientRect().top + scrollTopx - tooltip.clientHeight - 8

            let widthx = elx.clientWidth
            let leftx = elx.getBoundingClientRect().left - tooltip.clientWidth / 2 + widthx / 2

            if (this.position === 'bottom') {
                topx = elx.getBoundingClientRect().top + scrollTopx + elx.clientHeight + 8
            } else if (this.position === 'left') {
                leftx = elx.getBoundingClientRect().left - tooltip.clientWidth - 8
                topx =
                    elx.getBoundingClientRect().top +
                    scrollTopx +
                    elx.clientHeight / 2 -
                    tooltip.clientHeight / 2
                if (Math.sign(leftx) === -1) {
                    leftx = elx.getBoundingClientRect().left
                    topx = elx.getBoundingClientRect().top + scrollTopx + elx.clientHeight + 8
                    this.positionx = 'bottom'
                    this.noneAfter = true
                }
            } else if (this.position === 'right') {
                leftx = elx.getBoundingClientRect().left + elx.clientWidth + 8
                topx =
                    elx.getBoundingClientRect().top +
                    scrollTopx +
                    elx.clientHeight / 2 -
                    tooltip.clientHeight / 2
                if (window.innerWidth - (leftx + tooltip.clientWidth) <= 20) {
                    leftx = elx.getBoundingClientRect().left - tooltip.clientWidth / 2 - 10
                    topx = elx.getBoundingClientRect().top + scrollTopx + elx.clientHeight + 8
                    this.positionx = 'bottom'
                    this.noneAfter = true
                }
            }
            this.cords = {
                left: `${leftx}px`,
                top: `${topx}px`,
                width: `${widthx}px`
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.vs-tooltip {
    pointer-events: none;
    transition-duration: 0.2s !important;

    &:after {
        transform: rotate(45deg);
        margin: auto;
    }

    &.position-bottom:after {
        top: -4px;
        left: 0;
        right: 0;
    }
    &.position-top:after {
        bottom: -4px;
        left: 0;
        right: 0;
    }
    &.position-right:after {
        left: -4px;
        top: 0;
        bottom: 0;
    }
    &.position-left:after {
        right: -4px;
        top: 0;
        bottom: 0;
    }
}
.con-vs-tooltip {
    display: flex;
    align-items: center;
}
</style>
